import { type FC, memo, useMemo } from 'react';
import type { LineWithEntities } from '@/types';
import type { GroupedLinesProps, LineOutrightWithEntities } from '../../GroupedLines.types';
import { groupLines } from '../../GroupedLines.utils';
import { GroupedLinesContent } from '../GroupedLinesContent/GroupedLinesContent';
const BaseGroupedLinesSport: FC<GroupedLinesProps> = ({
  className,
  lines,
  isInSearch,
  variant
}) => {
  const groupedLines = useMemo(() => groupLines((lines as typeof lines extends Array<LineOutrightWithEntities> ? Array<LineOutrightWithEntities> : Array<LineWithEntities>)), [lines]);
  return <>
      {Array.from(groupedLines.entries()).map(([key, championshipLines]) => <GroupedLinesContent key={key} championshipLines={championshipLines} className={className} isInSearch={isInSearch} variant={variant} />)}
    </>;
};
export const GroupedLinesSport = memo(BaseGroupedLinesSport);
GroupedLinesSport.displayName = 'GroupedLinesSport';